import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(private translateService: TranslateService) { }


  //  restituisce un array associativo raggruppato per chiave
  static groupBy(arrayData, key)
  {
    if (arrayData != null && typeof arrayData != undefined && key != null) {
      return _.groupBy(arrayData, key);
    }

    return [];
  }

  //  restituisce un colore basato su un evento delle email
  static getColorByEmailEvent(event) {
    // Normalizza: trim, lowercase, spazi -> trattini (es. "Not Yet Sent" -> "not-yet-sent")
    const normalized = (event || '').toString().trim().toLowerCase().replace(/\s+/g, '-');

    switch (normalized) {
      case 'processed': //   la mail è stata processata e sarà inviata a breve
        return '#bca900';
      case 'dropped':
        return '#f44336'; //  la mail è stata droppata per diversi motivi e non sarà consegnata
      case 'deferred':
        return '#bca900'; //  la mail non è stata consegnata ma verranno effettuati altri tentativi di consegna
      case 'bounce':
        return '#f44336'; //  la mail è sarà consegnata perchè Sendgrid ha trovato incongruenze nella mail o nel suo destinatario
      case 'delivered':
      case 'delivery': //  alias italiano (backend può inviare in italiano)
        return '#477149'; //  la mail è stata consegnata (verde scuro per accessibilità/color blindness)
      case 'open':
        return '#4caf50'; //  la mail è stata aperta o dall'utente o dal client di posta
      case 'click':
        return '#4caf50'; //  l'utente ha cliccato su un link presente nella mail
      case 'spamreport':
        return '#f44336'; //  l'utente ha segnalato la mail come spam
      case 'unsubscribe':
        return '#f44336'; //  l'utente si è disiscritto dalla newsletter (evento non gestito)
      case 'not-yet-sent':
        return '#9e9e9e'; //  la mail non è ancora stata inviata
      default:
        return '#9e9e9e'; //  stato sconosciuto: grigio neutro
    }
  }
}
